<template>
  <BQdtCard
    name="turnoverhsTitle"
    type="header-item"
  />
</template>

<script>
import { BQdtCard } from '@/components/blocks'

export default {
  name: 'ValueOfGoodsHSCodeHeader',

  components: { BQdtCard },
}
</script>
